<template>
  <el-container class="home">
    <!-- 头部 -->
    <el-header>
      <div class="logo" v-if="userInfo&&userInfo.schoolLogo">
        <img :src="userInfo.schoolLogo" alt="">
      </div>
      <div class="title">
        <h1 v-if="pageLoadend">{{ userInfo.teacherSchoolList[0].orgName ? userInfo.teacherSchoolList[0].orgName :
            userInfo.teacherSchoolList[0].schoolName
        }}教师专业发展平台</h1>
      </div>
      <div class="logout">
        <el-popover placement="left-end" width="50" trigger="hover" content="个人中心">
          <span slot="reference" @click="goPersonal">{{ userName || "" }}</span>
        </el-popover>
        <a @click="logout" href="javascript:;"><i class="iconfont icon-tuichu"></i></a>
      </div>
    </el-header>
    <!-- 导航栏 和 内容 -->
    <template v-if="pageLoadend">
      <router-view></router-view>
    </template>

  </el-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["isAdmin", "userInfo", "pageLoadend"]),
  },
  data() {
    return {
      userName: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$store.commit("loadingStart");
      await this.$store.dispatch("getUserInfo");
      await this.$store.dispatch("getDic");
      this.$store.commit("loadingFinish");
    },
    logout() {
      this.$confirm("你确认要进行退出么?", "温馨提示", {
        type: "warning",
        confirmButtonClass: "logout-btn",
      })
        .then(() => {
          this.$axios
            .get("/oauth/logout")
            .then((res) => {
              if (res.resultCode === 200) {
                this.$message.success("恭喜, 退出成功");
                this.$router.push("/login");
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                  offset: 150,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //个人中心
    goPersonal() {
      this.$route.path.includes("personal/")
        ? ""
        : this.$router.push("/personal/info");
    },
  },
  watch: {
    "userInfo.userName": {
      handler(newValue) {
        this.userName = newValue;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  height: 100%;

  .el-header {
    background-color: @theme-color;
    display: flex;
    align-items: center;

    .logo {
      margin-right: 10px;
      background: white;
      border-radius: 50%;
      overflow: hidden;

      img {
        display: block;
        height: 48px;
        width: 48px;

      }
    }

    .title {
      flex: 1;

      h1 {
        font-weight: 700;
        font-size: 24px;
        height: 60px;
        line-height: 60px;
        text-align: left;
        color: #fff;
      }
    }

    .logout {
      margin-right: 20px;
      padding: 0px 10px;
      height: 60px;
      padding: 0px 20px;
      font-size: 19px;
      background-color: #ffd900;
      text-align: left;
      line-height: 60px;
      border-radius: 10px;
      cursor: pointer;

      span {
        float: left;
        padding-right: 10px;
      }

      a {
        float: right;

        .icon-tuichu {
          font-size: 19px;
          color: #000;
        }
      }
    }
  }
}
</style>
